export default __webpack_public_path__ + "static/media/caffeCapucitoOpen.b7b1ced0.jpg";